export default {"src":"/_next/static/media/youtube.cb6bd3ad.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};